/*
 * NOTE this is the main entry point for the MFE. This is where the MFE is bootstrapped.  It needs to be
 * imported because... TODO: figure out why this is needed.  It seems like it should be able to be imported
 */
import('./bootstrap');
